import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import GuidingPhilosophyImage from './AMK-presentation-approach.png';
import { SlideTitle } from '../slide-title';
import { SlideParagraph } from '../slide-paragraph';
import { SlideSubtitle } from '../slide-subtitle';

export const GuidingPhilosophy = (): React.ReactElement => {
  return (
    <Grid container gap={1} className={styles.container}>
      <Grid item>
        <SlideTitle>Guiding Philosophy, Goals & Principles</SlideTitle>
      </Grid>
      <Grid item>
        <SlideSubtitle>Guiding Philosophy</SlideSubtitle>
        <SlideParagraph>
          Investing is hard, especially during market downturns when investor
          emotions can take over and potentially harm the long-term goals of
          their portfolios. To help investors stay the course for the long-term
          and avoid making potentially harmful mistakes, a portfolio needs to
          have a strong foundation from which additional strategies can be added
          to help meet specific investor goals. It’s critical that the
          foundation provides exposure to asset classes that respond to changes
          in economic growth and inflation. We also experience different market
          regimes and investor goals where additional strategies can be applied
          to the foundation to tailor the solution for different client goals
          and asset levels.
        </SlideParagraph>

        <Grid
          container
          width="100%"
          height="285px"
          justifyContent="center"
          alignItems="center"
          display="flex"
          padding="10px"
        >
          <img
            src={GuidingPhilosophyImage}
            alt="Guiding Philosophy"
            style={{ maxWidth: '100%', height: '100%' }}
          />
        </Grid>
      </Grid>
      <Grid item>
        <SlideSubtitle>Guiding Goals</SlideSubtitle>
        <SlideParagraph>
          Build model portfolios that include a diverse mix of complementary
          investment strategies that play specific roles within the portfolio.
          Be able to simplify a sophisticated solution to effectively tell the
          portfolio story to clients.
        </SlideParagraph>
      </Grid>

      <Grid item>
        <SlideSubtitle>Guiding Principles for Model Design</SlideSubtitle>

        <ul style={{ margin: '8px 0' }}>
          <li>
            <SlideParagraph>
              Center portfolios around foundational core position of a broadly
              diversified US strategy.
            </SlideParagraph>
          </li>
          <li>
            <SlideParagraph>
              Complement with tactical equity and fixed income strategies for
              additional alpha opportunities and ability to limit portfolio
              drawdown.
            </SlideParagraph>
          </li>
          <li>
            <SlideParagraph>
              Include alternatives to provide diversification from
              non-correlation.
            </SlideParagraph>
          </li>
          <li>
            <SlideParagraph>
              Use of SMAs for higher net worth accounts to allow access to
              individual securities and more alpha opportunity while keeping the
              same story.
            </SlideParagraph>
          </li>
          <li>
            <SlideParagraph>
              Emphasis of strategies & mangers with consistent excess returns
              over broad benchmarks over rolling 1-, 3-, 5-year periods.
            </SlideParagraph>
          </li>
          <li>
            <SlideParagraph>
              Consideration for fees, specifically visible platform fees
            </SlideParagraph>
          </li>
        </ul>
      </Grid>
      <Grid item>
        <SlideParagraph style={{ fontSize: '10px', fontStyle: 'italic' }}>
          Note that AssetMark US/Global Market Blend is the default option for
          Core exposure in cases where an adviser has identified cost as a
          factor in the decision-making process and to the extent that an
          adviser is not seeking tactical, actively managed, factor-based or
          socially-focused Core exposure. The consideration of AssetMark
          proprietary strategies, including strategies that invest in funds
          managed by AssetMark, during the investment consulting process,
          creates a conflict of interest for AssetMark as AssetMark receives
          fees for the management of those strategies and funds.
        </SlideParagraph>
      </Grid>
    </Grid>
  );
};
